import { Component } from 'react'

import AsyncTypeahead from './AsyncTypeahead.jsx'

import api from '../../../../api.js'

export default class CitiesTypeahead extends Component {
  search = async (query) => {
    return (await api.cities.getAll({ keyword: query })).data
  }

  static defaultProps = {
    ...AsyncTypeahead.defaultProps,
    promptText: 'Entrez le nom des villes',
  }

  render() {
    const {...rest} = this.props

    return <AsyncTypeahead
      onSearch={this.search}
      selected={(this.props.input.value)}
      selectHintOnEnter
      multiple
      {...rest}
    />
  }
}
